import { isFemaleCycleSectionEnabledFromConfig } from "./client-configuration-helpers";

/**
 * Loads effective client configuration for an athlete portal view.
 * @param {import("@rill/loader").Load} load
 * @param {string | undefined} proxyAthlete
 */
export async function loadClientConfigurationForAthlete(load, proxyAthlete) {
  if (!proxyAthlete) {
    return;
  }
  await load("clientConfiguration", { proxyAthlete });
}

/**
 * Loads client config, then female cycle logs/settings when the section is on.
 * Falls back to legacy `locals.athlete.tasks` when the athlete is not migrated yet.
 * @param {{ load: import("@rill/loader").Load, locals: object, proxyAthlete: string | undefined }} params
 */
export async function loadClientConfigurationAndFemaleCycleIfEnabled({
  load,
  locals,
  proxyAthlete,
}) {
  if (!proxyAthlete) {
    return;
  }
  await loadClientConfigurationForAthlete(load, proxyAthlete);
  if (!isFemaleCycleSectionEnabledFromConfig(locals.clientConfiguration)) {
    return;
  }
  await Promise.all([
    load("femaleCycleLogs", { proxyAthlete }),
    load("femaleCycleSettings", { proxyAthlete }),
  ]);
}

export { isFemaleCycleSectionEnabledFromConfig };
